// TODO: make a parent class for this and ConfigCaseField (and other input fields)
import * as React from 'react';
import { TooltipHost, TextField, getTheme, IStackStyles } from '@fluentui/react';
import { AdminContext } from 'Store/Admin';
import { settingsFieldStyles } from './SettingsStyles';

interface ConfigFieldProps {
  id: string;
  label: string;
  tooltip: string;
  styles?: IStackStyles;
}

const MinDisplayNameLength = 3;
const MaxDisplayNameLength = 32;

export const DisplayNameField: React.FC<ConfigFieldProps> = props => {
  const { palette, fonts } = getTheme();

  const { state, dispatch } = React.useContext(AdminContext);
  const [showError, setError] = React.useState<boolean>(false);

  const onComponentChange = (newValue?: string): void => {
    if (!newValue || newValue.length > MaxDisplayNameLength || newValue.length < MinDisplayNameLength) {
      setError(true);
    } else {
      setError(false);
      dispatch({
        type: 'DISPLAY_NAME',
        payload: newValue
      });
      dispatch({
        type: 'IS_UPDATED',
        payload: true
      });
    }
  };

  const narrowTextFieldStyles = settingsFieldStyles(palette, fonts, '90%');
  return (
    <TooltipHost content={props.label} styles={props.styles}>
      <TextField
        key={props.id}
        id={props.id}
        label="Display Name"
        onChange={(e, newValue): void => onComponentChange(newValue)}
        value={state.queueDataState?.displayName}
        errorMessage={
          showError ? `Name must be between ${MinDisplayNameLength} and ${MaxDisplayNameLength} characters` : ''
        }
        styles={narrowTextFieldStyles}
      />
    </TooltipHost>
  );
};
